import React from 'react';
import {
	_getCheckQbToken, 
	_getCheckGdToken,
	_getGoogleDriveAuthUrl, 
	_postQbCode, 
	_getQbInitialiseSelections,
} from '../services';
import { connect } from 'react-redux';
import { Button, Row, Icon, Modal } from 'antd';
import OrderPageV3 from '../components/orders-v3/orderPageV3';

import { QUICKBOOKS_AUTH_URL } from '../index'

class OrdersPageV3 extends React.Component{
	constructor(props){
		super(props);

		this.state = {
			qbAccessToken:true
		}

		let qbCode = new URLSearchParams(this.props.location.search).get('code')

		_getCheckQbToken()
		.then( res => {
			// console.log(res)
			if(res.data.accessToken){
				this.setState({qbAccessToken: true})
			} else {
				this.setState({qbAccessToken:false})
				if(qbCode){
					_postQbCode(qbCode)
					.then(res => {
						if(res.data.success){
							this.setState({qbAccessToken:true})
							_getQbInitialiseSelections()
						}
					})
				}
			}
		})
	}
	render(){
		
		return (
			<div>
				<Modal
					centered={true}
					footer={null}
					width={300}
					visible={!this.state.qbAccessToken}
					closable={false}
				>
					<Row style={{marginBottom:16}} align="middle" type="flex" justify="center">
						<Button 
							disabled={this.state.qbAccessToken}
							onClick={this.handleAuthQuickBooks}
							style={{width:200,background:"#2ca01c", color:"#FFFFFF", marginRight:4}}
							>Authorise Quickbooks</Button>
					</Row>
				</Modal>

				<OrderPageV3/>
			</div>
		)
	}

	handleAuthQuickBooks = () =>{
		_getCheckQbToken()
		.then(res => {
			// console.log(res)
			if(!res.data.accessToken){
				window.open(QUICKBOOKS_AUTH_URL)
			} else {
				this.setState({qbAccessToken:true})
			}
		})
	}

}




export default connect(
	state => ({
		user: state.user,
		activeOrder: state.activeOrder
	})
)(OrdersPageV3);


// WEBPACK FOOTER //
// ./src/containers/order-page-v3.js